
import { DRAWER_WIDTH } from '../../constants/layout';
import { useIsSmallWeb } from './useIsSmallWeb';
import { useWindowDimensions } from 'react-native';

export const useAvailableDimensions = () => {
  const {width , height} = useWindowDimensions();
  const {hasLateralBar} = useIsSmallWeb();

  let widthAvailable = width;
  if(hasLateralBar){
    widthAvailable = width - DRAWER_WIDTH;
  }
  return {width: widthAvailable, height};
};